<template>
  <a-layout id="resetPassView" style="height: 100vh;">
    <!-- 美化弹窗组件 -->
    <BeautyModal
      :visible="modalVisible"
      :type="modalType"
      :title="modalTitle"
      :message="modalMessage"
      :extraInfo="modalExtraInfo"
      :confirmText="modalConfirmText"
      @confirm="handleModalConfirm"
      @close="handleModalClose"
    />
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content class="reset_content">
      <div class="reset_left">
        <img src="@/assets/bibLogin.png" alt=""/>
      </div>
      <div class="reset_right">
        <div class="reset_right_content">
          <!-- 返回按钮 -->
          <div class="back_box" @click="backChange()">
            <svg width="18" height="18" viewBox="0 0 18 18">
              <polyline points="12,4 6,9 12,14" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          
          <!-- 标题 -->
          <h1 class="reset-title">{{ $t('reset_password.title') }}</h1>
          
          <!-- 提示框 -->
          <div class="tipBox">
            <img src="@/assets/tipBox.png" alt="">
            <span>{{ $t('reset_password.enter_email_tip') }}</span>
          </div>
          
          <!-- 邮箱输入区域容器 -->
          <div class="email-section">
            <div class="email-container">
              <!-- 邮箱账号输入 -->
              <div class="label email-label">
                <div class="label-header">
                  <icon-email class="label-icon"/>
                  <p class="label-text">{{ $t('reset_password.email') }}</p>
                </div>
                <div class="input-wrapper">
                  <a-input 
                    class="input email-input" 
                    v-model="email" 
                    :placeholder="$t('reset_password.email_placeholder')" 
                    @input="checkEmail"
                    @focus="onEmailFocus"
                    @blur="onEmailBlur"
                    allow-clear>
                  <template #prefix>
                      <icon-email class="input-prefix-icon"/>
                    </template>
                  </a-input>
                  <div class="input-status" :class="{ 'show': email, 'valid': email && !is_email, 'invalid': email && is_email }">
                    <icon-check-circle v-if="email && !is_email" class="status-icon valid"/>
                    <icon-close-circle v-if="email && is_email" class="status-icon invalid"/>
                    <span v-if="email && !is_email" class="status-text valid">{{ $t('reset_password.email_format_correct') }}</span>
                    <span v-if="email && is_email" class="status-text invalid">{{ $t('reset_password.email_format_incorrect') }}</span>
                  </div>
                </div>
                              </div>
                            </div>
                          </div>
          
          <!-- 验证码输入区域 -->
          <div v-if="codeSent" class="verification-section">
            <div class="verification-container">
              <!-- 验证码输入 -->
              <div class="label verification-label">
                <div class="label-header">
                  <icon-safe class="label-icon"/>
                  <p class="label-text">{{ $t('reset_password.verification_code') }}</p>
                </div>
                <div class="input-wrapper">
                  <a-input 
                    class="input verification-input" 
                    v-model="vcode" 
                    :placeholder="$t('reset_password.verification_code_placeholder')" 
                    maxlength="6"
                    @input="checkVcode">
                    <template #prefix>
                      <icon-safe class="input-prefix-icon"/>
                  </template>
                </a-input>
                  <div class="input-status" :class="{ 'show': vcode, 'valid': vcode && !is_vcode, 'invalid': vcode && is_vcode }">
                    <icon-check-circle v-if="vcode && !is_vcode" class="status-icon valid"/>
                    <icon-close-circle v-if="vcode && is_vcode" class="status-icon invalid"/>
                    <span v-if="vcode && !is_vcode" class="status-text valid">{{ $t('reset_password.code_format_correct') }}</span>
                    <span v-if="vcode && is_vcode" class="status-text invalid">{{ $t('reset_password.code_format_incorrect') }}</span>
                  </div>
                </div>
              </div>
              
              <!-- 新密码输入 -->
              <div class="label password-label">
                <div class="label-header">
                  <icon-lock class="label-icon"/>
                  <p class="label-text">{{ $t('reset_password.new_password') }}</p>
                </div>
                <div class="input-wrapper">
                  <a-input-password 
                    class="input password-input" 
                    v-model="newPassword" 
                    :placeholder="$t('reset_password.new_password_placeholder')" 
                    @input="checkPassword">
                    <template #prefix>
                      <icon-lock class="input-prefix-icon"/>
                    </template>
                  </a-input-password>
                  <div class="input-status" :class="{ 'show': newPassword, 'valid': newPassword && !is_password, 'invalid': newPassword && is_password }">
                    <icon-check-circle v-if="newPassword && !is_password" class="status-icon valid"/>
                    <icon-close-circle v-if="newPassword && is_password" class="status-icon invalid"/>
                    <span v-if="newPassword && !is_password" class="status-text valid">{{ $t('reset_password.password_format_correct') }}</span>
                    <span v-if="newPassword && is_password" class="status-text invalid">{{ $t('reset_password.password_format_incorrect') }}</span>
                  </div>
                </div>
              </div>
              
              <!-- 确认密码输入 -->
              <div class="label confirm-password-label">
                <div class="label-header">
                  <icon-lock class="label-icon"/>
                  <p class="label-text">{{ $t('reset_password.confirm_password') }}</p>
                </div>
                <div class="input-wrapper">
                  <a-input-password 
                    class="input confirm-password-input" 
                    v-model="confirmPassword" 
                    :placeholder="$t('reset_password.confirm_password_placeholder')" 
                    @input="checkConfirmPassword">
                    <template #prefix>
                      <icon-lock class="input-prefix-icon"/>
                    </template>
                  </a-input-password>
                  <div class="input-status" :class="{ 'show': confirmPassword, 'valid': confirmPassword && !is_confirm_password, 'invalid': confirmPassword && is_confirm_password }">
                    <icon-check-circle v-if="confirmPassword && !is_confirm_password" class="status-icon valid"/>
                    <icon-close-circle v-if="confirmPassword && is_confirm_password" class="status-icon invalid"/>
                    <span v-if="confirmPassword && !is_confirm_password" class="status-text valid">{{ $t('reset_password.password_confirm_correct') }}</span>
                    <span v-if="confirmPassword && is_confirm_password" class="status-text invalid">{{ $t('reset_password.password_confirm_incorrect') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 发送验证码按钮 -->
          <a-button v-if="!codeSent" class="resetBtn" :disabled="!email || is_email" @click="sendResetCode">
            <icon-send class="btn-icon"/>
            <span>{{ $t('reset_password.send_code') }}</span>
          </a-button>
          
          <!-- 重置密码按钮 -->
          <a-button v-if="codeSent" class="resetBtn" :disabled="!canReset" @click="resetPassword">
            <icon-check class="btn-icon"/>
            <span>{{ $t('reset_password.reset_password') }}</span>
          </a-button>
          
          <!-- 底部链接 -->
          <div class="row">
            <div class="item" @click="toLogin">
              <span class="color-primary">{{ $t('reset_password.back_to_login') }}</span>
            </div>
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import common from '@/common/api/common.js';
import country from '../../common/area';
import util from "@/common/util";
import BeautyModal from '@/components/BeautyModal/BeautyModal.vue';


export default {
  name: "ResetPassView",
  components: {PageNav, BeautyModal},
  data() {
    return {
      country: country.countryList,
      phone_code: '+86',
      showCountry: false,
      phone: '',
      is_phone: false,
      email: '',
      is_email: false,
      type: 2, // 默认使用邮箱重置密码
      // 新增数据属性
      codeSent: false, // 验证码是否已发送
      vcode: '', // 验证码
      is_vcode: false, // 验证码格式错误
      newPassword: '', // 新密码
      is_password: false, // 密码格式错误
      confirmPassword: '', // 确认密码
      is_confirm_password: false, // 确认密码错误
      // 弹窗相关数据
      modalVisible: false,
      modalType: 'info',
      modalTitle: '',
      modalMessage: '',
      modalExtraInfo: '',
      modalConfirmText: '确定',
    }
  },
  computed: {
    // 是否可以重置密码
    canReset() {
      return this.codeSent && 
             this.vcode && !this.is_vcode && 
             this.newPassword && !this.is_password && 
             this.confirmPassword && !this.is_confirm_password;
    }
  },
  mounted() {
    console.log('🚀 忘记密码页面初始化完成');
    console.log('📧 邮箱重置模式已启用');
    console.log('🎨 忘记密码页面样式优化完成');
    console.log('✨ 与登录注册页面风格保持一致');
    console.log('📱 响应式设计已适配');
    console.log('⚡ 性能优化已完成');
    console.log('');
    console.log('🎯 忘记密码页面特色功能:');
    console.log('   📍 标题完美居中显示');
    console.log('   📧 邮箱标签特殊渐变背景');
    console.log('   ✨ 图标浮动动画效果');
    console.log('   🌟 悬停发光边框效果');
    console.log('   🎭 实时输入状态反馈');
    console.log('   🚀 重置按钮智能禁用');
    console.log('');
    console.log('📋 当前重置状态:', {
        email: this.email,
        emailValid: !this.is_email
    });
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    backChange() {
      this.$router.push("/login");
    },
    loginType(k) {
      this.type = k
    },
    checkPhone() {
      this.is_phone = !util.validatePhoneNumber(this.code + this.phone)
    },
    checkEmail() {
      this.is_email = !util.validateEmail(this.email);
      console.log('📧 邮箱验证:', {
        email: this.email,
        isValid: util.validateEmail(this.email),
        is_email: this.is_email
      });
    },
    onEmailFocus() {
      console.log('📧 邮箱输入框获得焦点');
    },
    onEmailBlur() {
      console.log('📧 邮箱输入框失去焦点');
    },
    // 弹窗处理方法
    showModal(type, title, message, extraInfo = '', confirmText = '确定') {
      this.modalType = type;
      this.modalTitle = title;
      this.modalMessage = message;
      this.modalExtraInfo = extraInfo;
      this.modalConfirmText = confirmText;
      this.modalVisible = true;
    },
    handleModalConfirm() {
      this.modalVisible = false;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
    // 验证码验证
    checkVcode() {
      this.is_vcode = !this.vcode || this.vcode.length !== 6 || !/^\d{6}$/.test(this.vcode);
      console.log('🔐 验证码验证:', {
        vcode: this.vcode,
        isValid: !this.is_vcode
      });
    },
    // 密码验证
    checkPassword() {
      this.is_password = !this.newPassword || this.newPassword.length < 8 || this.newPassword.length > 64;
      console.log('🔐 密码验证:', {
        password: this.newPassword,
        isValid: !this.is_password
      });
    },
    // 确认密码验证
    checkConfirmPassword() {
      this.is_confirm_password = !this.confirmPassword || this.confirmPassword !== this.newPassword;
      console.log('🔐 确认密码验证:', {
        confirmPassword: this.confirmPassword,
        newPassword: this.newPassword,
        isValid: !this.is_confirm_password
      });
    },
    countryOk(e) {
      this.code = e.dialingCode
    },
    async sendResetCode() {
      // 验证邮箱
      this.checkEmail();
      if (this.is_email) {
        this.$message.warning(this.$t('reset_password.invalid_email'));
        return;
      }

      if (!this.email.trim()) {
        this.$message.warning(this.$t('reset_password.email_required'));
        return;
      }

      try {
        console.log('📧 发送重置密码验证码...', this.email);
        console.log('📧 使用API: sendFindCode');
        
        const res = await common.sendFindCode(this.email, 2); // 2表示邮箱类型
        
        console.log('📧 API响应:', res);
        console.log('📧 响应类型:', typeof res);
        console.log('📧 响应代码:', res?.code);
        console.log('📧 响应消息:', res?.message || res?.msg);
        
        // 检查响应格式
        if (res && res.code === 200) {
          console.log('✅ 重置密码验证码发送成功');
          this.showModal(
            'success',
            this.$t('reset_password.code_sent_success'),
            this.$t('reset_password.code_sent_message'),
            this.$t('reset_password.code_sent_instruction'),
            this.$t('common.confirm')
          );
          
          // 显示验证码输入区域
          this.codeSent = true;
          
        } else if (res && res.code === 0) {
          console.log('✅ 重置密码验证码发送成功');
          this.showModal(
            'success',
            this.$t('reset_password.code_sent_success'),
            this.$t('reset_password.code_sent_message'),
            this.$t('reset_password.code_sent_instruction'),
            this.$t('common.confirm')
          );
          
          // 显示验证码输入区域
          this.codeSent = true;
          
        } else {
          const errorMsg = res?.message || res?.msg || this.$t('reset_password.send_failed_message');
          console.log('❌ 重置密码验证码发送失败:', errorMsg);
          this.showModal(
            'error',
            this.$t('reset_password.send_failed'),
            errorMsg,
            '',
            this.$t('common.confirm')
          );
        }
      } catch (error) {
        console.error('📧 重置密码验证码发送异常:', error);
        
        let errorMessage = this.$t('reset_password.send_failed_message');
        
        if (error.message) {
          if (error.message.includes('Network Error') || error.message.includes('网络连接失败')) {
            errorMessage = this.$t('reset_password.network_error_message');
          } else if (error.message.includes('timeout')) {
            errorMessage = this.$t('reset_password.timeout_message');
          } else {
            errorMessage = error.message;
          }
        }
        
        this.showModal(
          'error',
          this.$t('reset_password.network_error'),
          errorMessage,
          this.$t('reset_password.network_error_message'),
          this.$t('common.confirm')
        );
      }
    },
    // 重置密码
    async resetPassword() {
      // 验证所有输入
      this.checkVcode();
      this.checkPassword();
      this.checkConfirmPassword();
      
      if (this.is_vcode) {
        this.showModal(
          'warning',
          this.$t('reset_password.code_error'),
          this.$t('reset_password.code_error_message'),
          this.$t('reset_password.code_error_instruction'),
          this.$t('common.confirm')
        );
        return;
      }
      
      if (this.is_password) {
        this.showModal(
          'warning',
          this.$t('reset_password.password_format_error'),
          this.$t('reset_password.password_format_error_message'),
          this.$t('reset_password.password_format_error_instruction'),
          this.$t('common.confirm')
        );
        return;
      }
      
      if (this.is_confirm_password) {
        this.showModal(
          'warning',
          this.$t('reset_password.password_mismatch'),
          this.$t('reset_password.password_mismatch_message'),
          this.$t('reset_password.password_mismatch_instruction'),
          this.$t('common.confirm')
        );
        return;
      }
      
      try {
        console.log('🔐 开始重置密码...', {
          email: this.email,
          vcode: this.vcode,
          newPassword: this.newPassword
        });
        
        const res = await common.findPwdSet({
          account: this.email,
          code: this.vcode,
          password: this.newPassword,
          type: 2 // 邮箱类型
        });
        
        console.log('🔐 重置密码API响应:', res);
        
        if (res && res.code === 200) {
          console.log('✅ 密码重置成功');
          this.showModal(
            'success',
            this.$t('reset_password.reset_success'),
            this.$t('reset_password.reset_success_message'),
            this.$t('reset_password.reset_success_instruction'),
            this.$t('common.confirm')
          );
          
          // 1.5秒后自动跳转到登录页面
          setTimeout(() => {
            this.modalVisible = false;
            this.$router.push('/login');
          }, 1500);
          
        } else if (res && res.code === 0) {
          console.log('✅ 密码重置成功');
          this.showModal(
            'success',
            this.$t('reset_password.reset_success'),
            this.$t('reset_password.reset_success_message'),
            this.$t('reset_password.reset_success_instruction'),
            this.$t('common.confirm')
          );
          
          // 1.5秒后自动跳转到登录页面
          setTimeout(() => {
            this.modalVisible = false;
            this.$router.push('/login');
          }, 1500);
          
        } else {
          const errorMsg = res?.message || res?.msg || '密码重置失败，请重试';
          console.log('❌ 密码重置失败:', errorMsg);
          this.showModal(
            'error',
            this.$t('reset_password.reset_failed'),
            errorMsg,
            this.$t('reset_password.check_code_correct'),
            this.$t('common.retry')
          );
        }
      } catch (error) {
        console.error('🔐 密码重置异常:', error);
        
        let errorMessage = '密码重置失败，请稍后重试';
        
        if (error.message) {
          if (error.message.includes('Network Error') || error.message.includes('网络连接失败')) {
            errorMessage = '网络连接异常，请检查网络后重试';
          } else if (error.message.includes('timeout')) {
            errorMessage = '请求超时，请稍后重试';
      } else {
            errorMessage = error.message;
          }
        }
        
        this.showModal(
          'error',
          this.$t('reset_password.network_error'),
          errorMessage,
          this.$t('reset_password.network_error_message'),
          this.$t('common.retry')
        );
      }
    },
    // 保留这些方法以备将来使用
    isApiSuccess(response) {
      return response && (response.code === 200 || response.code === 0);
    },
    getApiErrorMessage(response, defaultMessage) {
      return response?.message || response?.msg || defaultMessage;
    }
  }
}
</script>
<style scoped>
.reset_right_content .back_box {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  cursor: pointer;
  z-index: 10;
  transition: box-shadow 0.2s, background 0.2s;
  border: none;
  padding: 0;
}
.reset_right_content .back_box:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  background: #f2f3f5;
}
.reset_right_content .back_box img {
  width: 18px;
  height: 18px;
  filter: brightness(0) contrast(100%);
  display: block;
}
</style>